/**
 * Holds the app router instance for non-React callers (e.g. auth-store OAuth redirect).
 * Registered from `createRouter()`; prefer `useRouter()` inside React.
 */

type AppRouterNavigate = (opts: {
	to: string;
	replace?: boolean;
}) => Promise<unknown>;

type AppRouter = {
	navigate: AppRouterNavigate;
};

let appRouter: AppRouter | null = null;

export function registerAppRouter(router: AppRouter): void {
	appRouter = router;
}

export function getAppRouter(): AppRouter | null {
	return appRouter;
}

/** Path + search + hash for same-origin absolute URLs; otherwise returns the input. */
export function toRouterPath(url: string): string {
	if (!url.startsWith("http://") && !url.startsWith("https://")) {
		return url;
	}
	try {
		const parsed = new URL(url);
		return `${parsed.pathname}${parsed.search}${parsed.hash}`;
	} catch {
		return url;
	}
}
